import Icon from "./IconBase.js";
const MenuIconWhite = (props) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 32 32"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.36169 7H20.5593H5.36169ZM5.36169 16H26.6383H5.36169ZM5.36169 25H20.5593H5.36169Z"
          fill="#ffffff"
        />
        <path
          d="M5.36169 7H20.5593M5.36169 16H26.6383M5.36169 25H20.5593"
          stroke="#ffffff"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default MenuIconWhite;
